/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Player_WaitlistedInputs */



/**
* | output |
* | --- |
* | "This player is on the waitlist — an organizer must promote them before check-in" |
*
* @param {Err_Tournament_Player_WaitlistedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_player_waitlisted = /** @type {((inputs?: Err_Tournament_Player_WaitlistedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Player_WaitlistedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce joueur est sur la liste d'attente — un organisateur doit le promouvoir avant le pointage")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este jugador está en la lista de espera — un organizador debe promoverlo antes del check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este jogador está na lista de espera — um organizador precisa promovê-lo antes do check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo giocatore è in lista d'attesa — un organizzatore deve promuoverlo prima del check in")
	return /** @type {LocalizedString} */ ("This player is on the waitlist — an organizer must promote them before check-in")
});